import type { PublicId } from './schema';

export type ContainerContext = SnippetContainerContext;

export const ContainerType = {
  SNIPPET: 'snippet',
} as const;

export interface BaseContainerContext {
  type: typeof ContainerType[keyof typeof ContainerType];
}

/**
 * Since an Action could belong to multiple snippets,
 * we track the workflow snippet parent action public id and the remote action public id.
 * This is pulled from the AO with key "linked_snippet_remote_action_map".
 * {
 *   "publicIdOfSnippetParentActionInWF": publicIdOfActionInTheSnippetRemote,
 * }
 */
export type SnippetRemoteActionMap = Record<PublicId, PublicId>;

export interface SnippetContainerContext extends BaseContainerContext {
  type: typeof ContainerType.SNIPPET;
  actionOptionPublicId: string; // id of the current action's action option public id
  snippetRemoteActionMap: SnippetRemoteActionMap;
}
